import { useAuraSupportInfo } from "src/Utils/Hooks/UseAuraInfoContext";
import { SupportRoles } from "src/Utils/Hooks/useGetAdminInfo/useGetAuraSupportInfo";

/**
 * Derives the current user's Aura Support portal privileges from the loaded /aura-support/me data.
 *
 * - `isSupportAdmin`  — true when the current user's role is Admin (read + write).
 *   Members are read-only; use this to disable/hide write operations.
 * - `isCurrentUser`   — true for the logged-in user's own row (used to block self role changes).
 */
export const useSupportPermissions = () => {
    const { adminDetails } = useAuraSupportInfo();

    const currentUserId = adminDetails?.currentUserId;
    const currentUser = adminDetails?.users?.find((user) => user.userId === currentUserId);
    const isSupportAdmin = currentUser?.role === SupportRoles.Admin;

    const isCurrentUser = (userId: string) => !!currentUserId && userId === currentUserId;

    return { isSupportAdmin, currentUserId, isCurrentUser };
};
